export class PushMessageDetailsModel {
  public id: number;
  public title: string;
  public message: string;
  public screenCode: Date;
  constructor() {
    this.id = 0;
    
  }
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-message-details/push-message-details.model.ts